import React from 'react';
import PropTypes from 'prop-types';
import {isArray, map} from 'lodash';

import TagList from './tag-list';

// Styles
import './extended-attributes-list.scss';

const ExtendedAttributes = [
    {label: 'Default', value: 'DEFAULT'},
    {label: 'Recommendations', value: 'RECOMMENDATIONS'},
    {label: 'New Releases', value: 'NEW_RELEASES'},
    {label: 'Recently Aired', value: 'RECENTLY_AIRED'},
    {label: 'Theater Release', value: 'THEATER_RELEASE'},
    {label: 'New To Dish', value: 'NEW_TO_DISH'},
];

const ExtendedAttributesList = ({handleUpdateExtAttributes, id, values}) => (
    <TagList
        filter={true}
        filterBy="label,value"
        filterPlaceholder="Extended Attribute"
        handleUpdateTag={handleUpdateExtAttributes}
        id={id}
        options={
            isArray(ExtendedAttributes)
                ? map(ExtendedAttributes, attrib => ({
                      label: attrib.label,
                      value: attrib.value,
                  }))
                : []
        }
        values={values}
    />
);

ExtendedAttributesList.propTypes = {
    handleUpdateExtAttributes: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
    values: PropTypes.array.isRequired,
};

export default ExtendedAttributesList;
